import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {ZadApiError} from '../zad/errors'
import {createZadDeliveryNote, fetchZadDeliveryNoteById, fetchZadDeliveryNoteBySale} from './service'
import {ZadDeliveryNoteState} from './types'

const initialState: ZadDeliveryNoteState = {
  saleDeliveryNote: null,
  lookupReady: false,
  lookupLoading: false,
  actionLoading: false,
  selectedDeliveryNote: null,
  error: null,
  errorCode: null,
  errorStatus: null,
}

function applyRejected(state: ZadDeliveryNoteState, action: PayloadAction<any>) {
  const payload = (action.payload || {}) as ZadApiError
  state.error = payload.error || 'Request failed'
  state.errorCode = payload.errorCode || null
  state.errorStatus = payload.status || null
}

function clearError(state: ZadDeliveryNoteState) {
  state.error = null
  state.errorCode = null
  state.errorStatus = null
}

const zadDeliveryNoteSlice = createSlice({
  name: 'zadDeliveryNotes',
  initialState,
  reducers: {
    clearZadDeliveryNoteError: (state) => {
      clearError(state)
    },
    clearSaleDeliveryNote: (state) => {
      state.saleDeliveryNote = null
      state.lookupReady = false
      state.lookupLoading = false
      clearError(state)
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchZadDeliveryNoteBySale.pending, (state) => {
      state.lookupLoading = true
      clearError(state)
    })
    builder.addCase(fetchZadDeliveryNoteBySale.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.lookupLoading = false
      state.lookupReady = true
    })
    builder.addCase(fetchZadDeliveryNoteBySale.fulfilled, (state, action) => {
      state.lookupLoading = false
      state.lookupReady = true
      clearError(state)
      state.saleDeliveryNote = action.payload.deliveryNote
    })

    builder.addCase(fetchZadDeliveryNoteById.pending, (state) => {
      state.actionLoading = true
    })
    builder.addCase(fetchZadDeliveryNoteById.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.actionLoading = false
    })
    builder.addCase(fetchZadDeliveryNoteById.fulfilled, (state, action) => {
      state.actionLoading = false
      state.selectedDeliveryNote = action.payload.deliveryNote
    })

    builder.addCase(createZadDeliveryNote.pending, (state) => {
      state.actionLoading = true
      clearError(state)
    })
    builder.addCase(createZadDeliveryNote.rejected, (state, action: PayloadAction<any>) => {
      applyRejected(state, action)
      state.actionLoading = false
    })
    builder.addCase(createZadDeliveryNote.fulfilled, (state, action) => {
      state.actionLoading = false
      clearError(state)
      state.saleDeliveryNote = action.payload.deliveryNote
      state.selectedDeliveryNote = action.payload.deliveryNote
      state.lookupReady = true
    })
  },
})

export default zadDeliveryNoteSlice.reducer
export const actions = zadDeliveryNoteSlice.actions
export {initialState as zadDeliveryNoteInitialState}
